<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" @click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="ap-modal-title-big">
            Изменить данные пользователя
        </div>
        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                Новый пароль (Если хотите изменить) <span class="red-text">*</span>
            </div>
            <input type="password" class="cd-modal-text-input" autocomplete="new-password" v-model="password">
            <div class="form-alert-danger" v-show="showAlert === 'password'">
                Обязательное поле!
            </div>
        </div>
        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                Подтверждение нового пароля <span class="red-text">*</span>
            </div>
            <input type="password" class="cd-modal-text-input" autocomplete="new-password" v-model="repeatedPassword">
            <div class="form-alert-danger" v-show="password !== repeatedPassword && repeatedPassword !== ''">
                Введённые пароли не совпадают!
            </div>
            <div class="form-alert-danger" v-show="showAlert === 'repeatedPassword'">
                Обязательное поле!
            </div>
        </div>
        <DataEntryFields :buttonName="'Применить'" :userData="userData" :showAlert="showAlert" @apply="apply"/>
    </div>
</template>

<script>
import DataEntryFields from "./DataEntryFields";
import SVGPhotoDnDLoad from "../../../SVG/SVGPhotoDnDLoad";
import SVGModalClose from "../../../SVG/SVGModalClose";

export default {
    name: "ChangeUser",
    components: {
        DataEntryFields,
        SVGPhotoDnDLoad,
        SVGModalClose
    },
    data(){
      return {
          password: '',
          repeatedPassword: '',
          showPasswordForm: false,
          necessaryFields: [
              'fullname',
              'email',
              'role'
          ],
          showAlert: null
      }
    },
    props: {
        userData: {
            type: Object
        }
    },
    methods: {
        checkNecessary(data) {
            for (let field in this.necessaryFields) {
                if (!data[this.necessaryFields[field]]) {
                    return this.necessaryFields[field]
                }
            }
            return true
        },
        checkPass(passOne, passTwo) {
            return passOne === passTwo
        },
        apply(newUserData) {
            let userDataForChange = {
                id: this.userData.id
            };
            if (this.password === this.repeatedPassword) {
                if(this.password.replace(/\s/g, '').length > 0){
                    userDataForChange.password = this.password;
                }
            }
            Object.assign(userDataForChange, newUserData);
            let checkResult = this.checkNecessary(userDataForChange)
            if (checkResult === true && this.checkPass(this.password, this.repeatedPassword)) {
                this.$emit('close');
                this.$store.dispatch('adminPanel/users/SAVE_USER', userDataForChange);
            } else {
                this.showAlert = checkResult
            }
        }
    }
}
</script>

<style scoped>

</style>
